const authManager = {

  setVendorManagerAccessToken: (accessToken) => {
    try {
      localStorage.setItem("accessVendorManagerToken", accessToken);
    } catch (error) {
      console.error("Error setting access token:", error);
    }
  },

  getVendorManagerAccessToken: () => {
    if (typeof window === "undefined") return null;
    return localStorage.getItem("accessVendorManagerToken");
  },

  deleteVendorManagerAccessToken: () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("accessVendorManagerToken");
    }
  },

  hasVendorManagerAccessToken: () => {
    if (typeof window === "undefined") return false;
    return !!localStorage.getItem("accessVendorManagerToken");
  },
};

export default authManager;
